import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { illustration } from '../../common/illustrations';
import { flag } from '../../common/flags';
import { standingResult, standingTags } from './StandingResult';
import { stayResult } from './StayOrGoResult';
import { moneyResult, moneyTags } from './MoneyResult';
import { retireResult, retireTags } from './RetireResult';
import { NEXT, nextUrl } from '../../common/next';
import { shareLink, shareText, nativeShare, whatsappUrl, copyText } from '../../common/share';
const FACTOR_ORDER = ['income', 'cost', 'citizenship', 'safety', 'community', 'schools', 'climate'];
const STATUS = {
  citizen: 'You already hold this passport',
  likely: 'You meet the basics',
  possible: 'Possible with work',
  hard: 'Hard today'
};
const shortDate = iso => new Date(iso + 'T12:00:00').toLocaleDateString(undefined, {
  month: 'short',
  year: 'numeric'
});

/**
 * /assessments/results/{id}  A member's saved results: the country ranking, one country at a time, with the
 * answers folded away underneath. If no country has scores yet it says the ranking is being prepared.
 */
export default class ResultPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.error = null;
    this.deleting = false;
    app.setTitle('Your results');
    app.setTitleCount(0);
    if (!app.session.user) {
      this.error = 'Log in to see your saved results.';
      return;
    }
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/assessment-results/' + encodeURIComponent(m.route.param('id')),
      errorHandler: () => {}
    }).then(d => {
      this.data = d;
      app.setTitle(d.assessment.name);
      this.promptTopics();
    }).catch(() => this.error = 'These results could not be found on your account.').finally(() => m.redraw());
  }

  /**
   * New members from okjapa.com land here rather than on the home page, so FoF Follow Tags' own first-visit
   * prompt never shows for them. Open it here, once, focused on life abroad (voucha-theme limits the list).
   */
  promptTopics() {
    if (!app.forum.attribute('fofFollowTagsPromptShouldPrompt')) return;
    try {
      if (sessionStorage.getItem('voucha-topics-prompted')) return;
      sessionStorage.setItem('voucha-topics-prompted', '1');
    } catch (e) {}
    setTimeout(() => {
      try {
        const shown = app.modal.show(() => flarum.reg.asyncModuleImport('ext:fof/follow-tags/forum/components/ChooseTagsToFollowModal'), {
          hasNotChosenYet: true,
          vouchaFocus: 'diaspora'
        });
        if (shown && shown.catch) shown.catch(() => {});
      } catch (e) {}
    }, 600);
  }

  /** Tags to join under a money questionnaire's result (only tags that exist here) */
  joinTags(scores) {
    if (scores.kind === 'money') return scores.home ? moneyTags(scores) : [];
    if (scores.kind === 'retire') return scores.places ? retireTags(scores) : [];
    return scores.country ? standingTags(scores) : [];
  }
  view() {
    if (this.error) {
      return m("div", {
        className: "VAssessResult container"
      }, m("div", {
        className: "VAssessClaim-card"
      }, m("p", null, this.error)));
    }
    if (!this.data) return m("div", {
      className: "VAssessResult container"
    }, m(LoadingIndicator, null));
    const d = this.data;
    return m("div", {
      className: "VAssessResult container"
    }, m("h4", {
      className: "App-titleControl App-titleControl--text"
    }, "Your ", d.assessment.name), m("header", {
      className: "VAssessResult-head"
    }, m("span", {
      className: "VAssessResult-pic",
      "aria-hidden": "true"
    }, m.trust(illustration(d.scores && d.scores.kind === 'standing' ? 'ladder' : d.scores && d.scores.kind === 'stay-or-go' ? 'scales' : d.scores && d.scores.kind === 'money' ? 'piggy-bank' : d.scores && d.scores.kind === 'retire' ? 'house-flag' : 'compass'))), m("h1", null, "Your ", d.assessment.name)), d.scores && d.scores.kind === 'standing' && d.scores.years ? standingResult(d.scores) : d.scores && d.scores.kind === 'retire' ? d.scores.places ? retireResult(d.scores) : m("div", {
      className: "VAssessResult-pending"
    }, m("strong", null, "We can't work this one out yet."), m("p", null, d.scores.error || 'Something is missing.', " Your answers are saved; this page will show your result once it's there.")) : d.scores && d.scores.kind === 'money' ? d.scores.number !== undefined ? moneyResult(d.scores) : m("div", {
      className: "VAssessResult-pending"
    }, m("strong", null, "We can't work this one out yet."), m("p", null, d.scores.error || 'Something is missing.', " Your answers are saved; this page will show your result once it's there.")) : d.scores && d.scores.kind === 'stay-or-go' ? d.scores.scenarios ? stayResult(d.scores) : m("div", {
      className: "VAssessResult-pending"
    }, m("strong", null, "We can't work this one out yet."), m("p", null, d.scores.error || 'Something is missing for this country.', " Your answers are saved; this page will show your result once it's there.")) : d.scores && d.scores.countries && d.scores.countries.some(c => c.match !== null) ? this.ranking(d.scores) : m("div", {
      className: "VAssessResult-pending"
    }, m("strong", null, "Your country ranking is being prepared."), m("p", null, "We're adding the latest figures for each country. Your ranking will appear on this page; you won't need to take the quiz again.")), d.scores && d.scores.countries && d.shareUrl ? this.share(d) : null, d.scores && ['standing', 'stay-or-go', 'money', 'retire'].includes(d.scores.kind) ? this.joinTags(d.scores).length ? m("section", {
      className: "VAssessResult-section"
    }, m("h2", null, "Join the conversation"), m("div", {
      className: "VAssessResult-links"
    }, this.joinTags(d.scores).map(t => m("a", {
      className: "Button",
      href: app.route('tag', {
        tags: t.slug()
      })
    }, t.name())))) : null : m("section", {
      className: "VAssessResult-section"
    }, m("h2", null, "Talk to Nigerians who've done it"), m("div", {
      className: "VAssessResult-links"
    }, m("a", {
      className: "Button",
      href: app.route('tag', {
        tags: 'japa'
      })
    }, "Japa: leaving Nigeria"), m("a", {
      className: "Button",
      href: app.route('tag', {
        tags: 'jjc'
      })
    }, "JJC: new abroad"), m("a", {
      className: "Button",
      href: app.route('tag', {
        tags: 'diaspora'
      })
    }, "Life abroad"))), NEXT[d.assessment.slug] ? m("section", {
      className: "VAssessResult-section VAssessResult-next"
    }, m("h2", null, "Next: ", NEXT[d.assessment.slug].name), m("p", null, NEXT[d.assessment.slug].line), m("a", {
      className: "Button Button--primary",
      href: nextUrl(d.shareUrl, NEXT[d.assessment.slug].slug),
      target: "_blank",
      rel: "noopener"
    }, "Start it on okjapa")) : null, m("details", {
      className: "VAssessResult-section VAssessResult-answersBox"
    }, m("summary", null, "Your answers ", m("small", null, "(", d.answers.length, ")")), m("dl", {
      className: "VAssessResult-answers"
    }, d.answers.map(a => [m("dt", null, a.question), m("dd", null, a.answer)]))), m("p", {
      className: "VAssessResult-note"
    }, "Only you can see these results. They're also under ", m("strong", null, "My results"), " on your profile.", ' ', m(Button, {
      className: "Button Button--link",
      loading: this.deleting,
      onclick: () => this.remove()
    }, "Delete them")));
  }

  /**
   * One country at a time: match score and rank at the top; flag, the criteria and a ring chart of where the
   * points come from; the selected criterion's details below. Back/next arrows (or swipe, or the arrow keys)
   * move through the ranking, and the selected criterion stays selected so countries are easy to compare.
   */
  ranking(scores) {
    const labels = scores.factorLabels || {};
    const list = scores.countries.filter(c => c.match !== null);
    const n = list.length;
    if (this.at === undefined) this.at = 0;
    if (!this.pick) this.pick = 'overview';
    const i = Math.min(this.at, n - 1);
    const c = list[i];
    const go = to => {
      this.at = (to + n) % n;
    };
    const factors = FACTOR_ORDER.filter(f => c.factors[f]);
    const top3 = Object.entries(scores.weights || {}).filter(_ref => {
      let [, w] = _ref;
      return w > 0;
    }).sort((a, b) => b[1] - a[1]).slice(0, 3).map(_ref2 => {
      let [f] = _ref2;
      return (labels[f] || f).toLowerCase();
    });
    const r = c.route;
    const prev = list[(i - 1 + n) % n];
    const next = list[(i + 1) % n];
    return m("section", {
      className: "VAssessResult-section"
    }, m("h2", null, "Your countries, ranked"), m("p", {
      className: "VAssessResult-method"
    }, "Scored out of 100 from published figures. What counts most for you: ", top3.slice(0, -1).join(', ') + (top3.length > 1 ? ' and ' : '') + top3[top3.length - 1], "."), m("div", {
      className: "VAssessSlide",
      tabindex: "0",
      role: "group",
      "aria-roledescription": "country",
      "aria-label": c.name + ', ranked ' + (i + 1) + ' of ' + n,
      onkeydown: e => {
        if (e.target !== e.currentTarget && e.target.getAttribute('role') !== 'tab') return;
        if (e.key === 'ArrowLeft') go(i - 1);else if (e.key === 'ArrowRight') go(i + 1);else e.redraw = false;
      },
      ontouchstart: e => {
        this.touchX = e.touches[0].clientX;
        e.redraw = false;
      },
      ontouchend: e => {
        const dx = e.changedTouches[0].clientX - (this.touchX || 0);
        if (Math.abs(dx) > 60) go(dx < 0 ? i + 1 : i - 1);else e.redraw = false;
      }
    }, m("div", {
      className: "VAssessSlide-top"
    }, m("div", {
      className: "VAssessSlide-score",
      "aria-label": 'Match score ' + c.match + ' out of 100'
    }, m("b", null, c.match), m("small", null, "match")), m("div", {
      className: "VAssessSlide-title"
    }, m("h3", null, c.name), m("div", {
      className: 'VAssessRank-route is-' + (r ? r.status : 'none')
    }, m("span", {
      className: "VAssessRank-status"
    }, r ? STATUS[r.status] || r.status : 'Visa routes still being checked'), c.considering ? m("span", {
      className: "VAssessSlide-badge"
    }, "You're considering") : null)), m("div", {
      className: "VAssessSlide-rank",
      "aria-label": 'Ranked ' + (i + 1) + ' of ' + n
    }, m("b", null, i + 1), m("small", null, "of ", n))), m("div", {
      className: "VAssessSlide-body"
    }, m("div", {
      className: "VAssessSlide-flag"
    }, m.trust(flag(c.code))), m("div", {
      className: "VAssessSlide-criteria",
      role: "tablist",
      "aria-label": "What the score is made of"
    }, ['overview'].concat(factors).map(f => {
      const row = c.factors[f];
      const on = this.pick === f;
      return m("button", {
        type: "button",
        role: "tab",
        "aria-selected": on ? 'true' : 'false',
        className: 'VAssessSlide-crit' + (on ? ' is-on' : '') + (row && row.weight <= 0 ? ' is-off' : ''),
        onclick: () => this.pick = f
      }, m("span", null, f === 'overview' ? 'Overview' : labels[f] || f), row ? m("b", null, row.score) : null);
    })), m("div", {
      className: "VAssessSlide-graph"
    }, this.ring(c, factors, labels)), m("div", {
      className: "VAssessSlide-text",
      role: "tabpanel"
    }, this.pick === 'overview' ? this.overview(c, labels) : this.factorText(c, this.pick, labels))), m("nav", {
      className: "VAssessSlide-nav",
      "aria-label": "Countries"
    }, m("button", {
      type: "button",
      className: "VAssessSlide-arrow",
      onclick: () => go(i - 1),
      "aria-label": 'Back: ' + prev.name
    }, m("i", {
      className: "fas fa-arrow-left",
      "aria-hidden": "true"
    }), m("span", null, prev.name)), m("span", {
      className: "VAssessSlide-dots"
    }, list.map((x, j) => m("button", {
      type: "button",
      className: j === i ? 'is-on' : '',
      "aria-label": j + 1 + '. ' + x.name,
      "aria-current": j === i ? 'true' : undefined,
      title: j + 1 + '. ' + x.name,
      onclick: () => go(j)
    }))), m("button", {
      type: "button",
      className: "VAssessSlide-arrow is-next",
      onclick: () => go(i + 1),
      "aria-label": 'Next: ' + next.name
    }, m("span", null, next.name), m("i", {
      className: "fas fa-arrow-right",
      "aria-hidden": "true"
    })))), m("p", {
      className: "VAssessResult-note"
    }, "Not immigration advice. Rules change, so check the official page for each route before you apply."));
  }

  /** Points each criterion adds to the match score (they add up to the score) */
  points(c, f) {
    const total = Object.values(c.factors).reduce((s, row) => s + (row.weight > 0 ? row.weight : 0), 0);
    const row = c.factors[f];
    return row && row.weight > 0 && total > 0 ? row.score * row.weight / total : 0;
  }

  /** Ring chart: each counted criterion is a segment as long as the points it adds; the filled part is the match score */
  ring(c, factors, labels) {
    const R = 48;
    const C = 2 * Math.PI * R;
    const GAP = 1.6;
    let start = 0;
    const segments = factors.filter(f => c.factors[f].weight > 0).map(f => {
      const pts = this.points(c, f);
      const len = pts / 100 * C;
      const seg = {
        f,
        pts,
        len,
        start
      };
      start += len;
      return seg;
    });
    const picked = this.pick !== 'overview' ? c.factors[this.pick] : null;
    return m("svg", {
      viewBox: "0 0 120 120",
      className: 'VAssessRing' + (this.pick !== 'overview' ? ' is-picking' : ''),
      role: "img",
      "aria-label": 'Match ' + c.match + ' out of 100'
    }, m("circle", {
      className: "VAssessRing-track",
      cx: "60",
      cy: "60",
      r: R
    }), segments.map(s => m("circle", {
      className: 'VAssessRing-seg' + (this.pick === s.f ? ' is-on' : ''),
      cx: "60",
      cy: "60",
      r: R,
      "stroke-dasharray": Math.max(0.5, s.len - GAP) + ' ' + C,
      "stroke-dashoffset": -s.start,
      transform: "rotate(-90 60 60)",
      onclick: () => this.pick = s.f
    }, m("title", null, (labels[s.f] || s.f) + ': ' + c.factors[s.f].score + '/100, adds ' + s.pts.toFixed(1) + ' points'))), m("text", {
      x: "60",
      y: "60",
      className: "VAssessRing-num"
    }, picked ? picked.score : c.match), m("text", {
      x: "60",
      y: "78",
      className: "VAssessRing-sub"
    }, picked ? 'out of 100' : 'match'));
  }
  overview(c, labels) {
    const r = c.route;
    return m("div", null, c.strongest ? m("p", null, "Strongest for you: ", m("strong", null, labels[c.strongest] || c.strongest), ". Tap a criterion to see the figure behind it.") : null, r && r.status !== 'citizen' ? m("p", null, "Visa route: ", r.officialUrl ? m("a", {
      href: r.officialUrl,
      target: "_blank",
      rel: "noopener"
    }, r.label) : r.label, r.checkedOn ? m("small", null, " (checked ", shortDate(r.checkedOn), ")") : m("small", null, " (not yet checked)")) : null, r && r.gaps && r.gaps.length ? m("div", {
      className: "VAssessRank-list"
    }, m("strong", null, "For you to sort out"), m("ul", null, r.gaps.map(g => m("li", null, g)))) : null, r && r.steps && r.steps.length ? m("div", {
      className: "VAssessRank-list is-steps"
    }, m("strong", null, "You'll also need"), m("ul", null, r.steps.map(g => m("li", null, g)))) : null);
  }
  factorText(c, f, labels) {
    const row = c.factors[f];
    const name = labels[f] || f;
    if (!row) return m("p", null, "We don't have a figure for ", name.toLowerCase(), " in ", c.name, " yet, so it isn't counted here.");
    const pts = this.points(c, f);
    return m("div", null, m("p", {
      className: "VAssessSlide-figure"
    }, row.figure), m("p", null, m("strong", null, row.score, "/100"), row.weight > 0 ? ' · ' + Math.round(row.weight) + '% of your score, so it adds ' + pts.toFixed(1) + ' of the ' + c.match + ' points.' : f === 'schools' ? " · Not counted for you, as you're not moving with children." : ' · Not counted for you.'), row.source ? m("p", {
      className: "VAssessSlide-source"
    }, "Source: ", row.source.url ? m("a", {
      href: row.source.url,
      target: "_blank",
      rel: "noopener"
    }, row.source.name) : row.source.name, row.asOf ? ', ' + shortDate(row.asOf) : '') : null);
  }

  /** Share the best match (and the next two names) as a link to the quiz on okjapa.com; answers are never shared */
  share(d) {
    const list = d.scores.countries.filter(c => c.match !== null);
    if (!list.length) return null;
    const top = list[0];
    const url = shareLink(d.shareUrl, top, list.slice(1, 3).map(c => c.code));
    const text = shareText(top.name, top.match);
    const copy = async () => {
      this.copied = await copyText(text + ' ' + url);
      m.redraw();
      setTimeout(() => {
        this.copied = false;
        m.redraw();
      }, 2500);
    };
    return m("section", {
      className: "VAssessResult-section VAssessShare"
    }, m("h2", null, "Share your result"), m("p", {
      className: "VAssessResult-method"
    }, "Friends see your best match, ", top.name, " at ", top.match, "/100, and the next two country names, then can take the quiz themselves. Your answers are never shared."), m("div", {
      className: "VAssessShare-btns"
    }, m("a", {
      className: "Button VAssessShare-wa",
      href: whatsappUrl(text, url),
      target: "_blank",
      rel: "noopener"
    }, m("i", {
      className: "fab fa-whatsapp",
      "aria-hidden": "true"
    }), " WhatsApp"), m("button", {
      type: "button",
      className: "Button",
      onclick: copy
    }, m("i", {
      className: 'fas fa-' + (this.copied ? 'check' : 'link'),
      "aria-hidden": "true"
    }), " ", this.copied ? 'Link copied' : 'Copy link'), navigator.share ? m("button", {
      type: "button",
      className: "Button",
      onclick: () => nativeShare('Japa Compass', text, url)
    }, m("i", {
      className: "fas fa-share-alt",
      "aria-hidden": "true"
    }), " More") : null));
  }
  async remove() {
    if (!confirm('Delete these results from your account? This cannot be undone.')) return;
    this.deleting = true;
    try {
      await app.request({
        method: 'DELETE',
        url: app.forum.attribute('apiUrl') + '/assessment-results/' + this.data.id,
        errorHandler: () => {}
      });
      m.route.set('/');
    } catch (e) {
      this.deleting = false;
      m.redraw();
    }
  }
}
flarum.reg.add('voucha-assessments', 'forum/components/ResultPage', ResultPage);